import React from "react"
import { Row, Col } from "reactstrap"
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components"
import ContainerMax from "components/shared/ContainerMax"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { media } from "utils/Media"

const Text = styled.div`
    h1, h2 {
        font-size: ${props => props.theme.font.h2.size};
        @media ${media.md} {
            font-size: ${props => props.theme.font.h1.size};
        }
    }
`

const ImgWrap = styled.div`
    overflow: hidden;
    img {
        transform: scale(1);
        transition: all .4s ease !important;
        &:hover {
            transform: scale(1.05);
        }
    }
`

const ImageTextV2 = (props) => {

    let id = ""
    if (props.block.anchorId !== null) {
        id = props.block.anchorId.toLowerCase()
        id = props.block.anchorId.replace(' ', '')
    }

    return (
        <ContainerMax 
            id={id}
            maxWidth="1360"
            className="py-4"
        >
            <Row>
                <Col md={{ size: 6, order: props.block.imagePosition === "right" ? 2 : 1 }}>
                    <ImgWrap>
                        <GatsbyImage image={props.block.image.localFile.childImageSharp.gatsbyImageData} />   
                    </ImgWrap> 
                </Col>
                <Col md={{ size: 6, order: props.block.imagePosition === "right" ? 1 : 2 }} >
                    <Text dangerouslySetInnerHTML={{ __html: LinkSearchReplace(props.block.text)}} className="py-4 pb-md-4 pt-md-0" />
                </Col>
            </Row>
        </ContainerMax>
    );
}

export default ImageTextV2